import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'findTag', standalone: true })
export class FindTagPipe implements PipeTransform {
  transform(stats: any[], key: string): any {
    return stats?.find(s => s.key === key) ?? null;
  }
}
